import { Container, Nav, Navbar } from 'react-bootstrap';
import { Outlet, NavLink } from 'react-router-dom';
import './Navigation.css'
import i18next, { changeLanguage } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

function Navigation() {

    const [currentLanguage, setCurrentLanguage] = useState(i18next.language || 'pl'); // default to English

    const handleNavClick = (event, sectionId) => {
        event.preventDefault();
        const targetSection = document.querySelector(sectionId);
        if (targetSection) {
            let offset = 0;

            switch (sectionId) {
                case '#section_1':
                    offset = 190;
                    break;
                case '#section_2':
                    offset = 90;
                    break;
                case '#section_3':
                    offset = 90;
                    break;
                case '#section_4':
                    offset = 90 * 2.1;
                    break;
                case '#section_5':
                    offset = 90 * 2;
                    break;
            }

            const sectionPosition = targetSection.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
                top: sectionPosition,
                behavior: 'smooth'
            });
        }
    };

    const switchLanguage = (language) => {
        i18next.changeLanguage(language);
        setCurrentLanguage(language); 
    };

    const getLanguageIcon = (language) => {
        switch (language) {
            case 'en':
                return 'icons/eng_icon.svg';
            case 'de':
                return 'icons/den_icon.svg';
            case 'pl':
                return 'icons/pol_icon.svg';
            default:
                return 'icons/pol_icon.svg'; 
        }
    };

    const {t} = useTranslation()

    return (
        <>
            <Navbar expand="lg" className='navigation' data-bs-theme="dark" fixed='top'>
                <Container>
                    <div className='d-flex justify-content-center align-items-center'>
                        <Navbar.Brand href="#">
                            <img src="kam-tech-logo-white-transparent.png" height="64" />
                        </Navbar.Brand>
                    </div>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav" className="justify-content-between">
                        <Nav className="mx-auto navigation-middle">
                            <Nav.Link className='mx-1 navigation-middle-text'
                                onClick={(e) => handleNavClick(e, '#section_1')}>{t("navigation.aboutus")}</Nav.Link>
                            <Nav.Link className='mx-1 navigation-middle-text'
                                onClick={(e) => handleNavClick(e, '#section_2')}>{t("navigation.opinions")}</Nav.Link>
                            <Nav.Link className='mx-1 navigation-middle-text'
                                onClick={(e) => handleNavClick(e, '#section_3')}>{t("navigation.castle")}</Nav.Link>
                            <Nav.Link className='mx-1 navigation-middle-text'
                                onClick={(e) => handleNavClick(e, '#section_4')}>{t("navigation.findus")}</Nav.Link>
                            <Nav.Link className='mx-1 navigation-middle-text'
                                onClick={(e) => handleNavClick(e, '#section_5')}>{t("navigation.contact")}</Nav.Link>
                        </Nav>
                        <Nav className='d-flex justify-content-center align-items-center navigation-contact'>
                            <Nav.Item className='my-auto'>
                                {currentLanguage !== 'en' && (
                                    <img src={getLanguageIcon('en')} className='mx-1' alt="eng" onClick={() => switchLanguage('en')} />
                                )}
                                {currentLanguage !== 'de' && (
                                    <img src={getLanguageIcon('de')} className='mx-1' alt="de" onClick={() => switchLanguage('de')} />
                                )}
                                {currentLanguage !== 'pl' && (
                                    <img src={getLanguageIcon('pl')} className='mx-1' alt="pl" onClick={() => switchLanguage('pl')} />
                                )}
                            </Nav.Item>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Outlet />
        </>

    )
}

export default Navigation